var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D47",
    fillRule: "evenodd",
    d: "M3.44 3.44A1.5 1.5 0 0 1 4.5 3h5.25a.75.75 0 0 1 0 1.5H4.5v15h5.25a.75.75 0 0 1 0 1.5H4.5A1.5 1.5 0 0 1 3 19.5v-15c0-.398.158-.78.44-1.06",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D47",
    fillRule: "evenodd",
    d: "M9 12a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H9.75A.75.75 0 0 1 9 12",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D47",
    fillRule: "evenodd",
    d: "M15.97 7.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 1 1-1.06-1.06L19.19 12l-3.22-3.22a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })));
};
export default SvgLogout;